export const ConsentType = {
  DATA_SHARING: 'DATA_SHARING',
  PAYMENT: 'PAYMENT',
  SERVICE: 'SERVICE',
};
